import RowGrid from './src/RowGrid'

RowGrid.install = function (Vue) {
    Vue.component(RowGrid.name, RowGrid);
};

export default RowGrid;